/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import SignupAboutForm from './SignupAboutForm';
import styles from 'src/shared/app/signup/component/profile/base/BaseSignupProfile.style';
import messages from 'src/shared/app/signup/l10n/aboutSignupL10n';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  handleSubmit: (Object) => Promise<any>,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const SignupAboutSection = ({ handleSubmit, intl }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <section className={classes.root}>
      <ZIndexTopBar>
        <TopBar title={intl.formatMessage(messages.heading)} />
      </ZIndexTopBar>
      <SignupAboutForm handleSubmit={handleSubmit} />
    </section>
  );
};

export default compose(React.memo, injectIntl)(SignupAboutSection);
